import { Button } from "@design";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Page } from "@/components/Page";

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(["errors", "common"]);
  return (
    <Page
      title={t("notFound.title")}
      subtitle={t("notFound.subtitle")}
      actions={
        <Button variant="secondary" onClick={() => navigate("/")}>
          {t("common:goHome")}
        </Button>
      }
    />
  );
}
